import { SearchState } from '../../../models';
import { SEARCH_GETTERS_KEYS } from '../search.const';
import { SearchGetter } from '../search.interfaces';

export class HasResultsGetter implements SearchGetter {

  getters = {
    [SEARCH_GETTERS_KEYS.hasResults]: (searchState: SearchState): boolean => {
      return !!searchState.results.length;
    }
  };
}
